import { Avatar, Badge, Box, Drawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { BsBagCheck } from "react-icons/bs";
import { IoBagOutline } from "react-icons/io5";
import { MdCancel, MdClose, MdMenu } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { ALL_SIDE_NAV_LIST, HEADER_ITEMS } from "../../constant/AppConstant";
import CartDrawer from "../../pages/FindParkingSlot/CartDrawer/CartDrawer";
import { useAppSelector } from "../../redux/app/hooks";
import {
  useLoginUserMutation,
  useLogoutUserMutation,
} from "../../redux/services/authApi";
import { useFindByCartIdMutation } from "../../redux/services/cartApi";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import {
  getCustomerId,
  getUserData,
  selectJwtToken,
  setUser,
} from "../../redux/slices/authSlice";
import {
  getCartData,
  resetCartData,
  setCart,
} from "../../redux/slices/cartSlice";
import {
  resetCustomer,
  selectCustomerData,
  setCustomer,
} from "../../redux/slices/customerSlice";
import RegularModal from "../Modals/RegularModal";
import { resetNav } from "../../redux/slices/navSlice";
import { reset } from "../../redux/slices/authSlice";

type Props = {
  position: string;
  isLoggedIn?: boolean;
  isLoggedOut?: boolean;
  logo?: string;
};

const Header = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customerId = useSelector(getCustomerId);
  const userData = useSelector(getUserData);
  const customerData = useSelector(selectCustomerData);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const bookingData = JSON.parse(localStorage.getItem("bookingData") || "{}");
  const [sidebar, setSidebar] = useState(false);
  const [isHeader, setIsHeader] = useState(true);
  const [logoutUser, logoutResponse] = useLogoutUserMutation();
  const [loginUser, loginResponse] = useLoginUserMutation();
  const [visible, setVisible] = useState(false);
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  const navList = props.isLoggedIn ? HEADER_ITEMS : HEADER_ITEMS;
  const navLists = props.isLoggedIn ? ALL_SIDE_NAV_LIST : HEADER_ITEMS;
  const isLoggedIn = props.isLoggedIn;
  const cartData: any = useAppSelector(getCartData);
  const [displays, setDisplays] = useState(false);
  const [display, setDisplay] = useState(false);
  const [findByCartId, finbByCartIdResponse] = useFindByCartIdMutation();
  const [findCustomerDetailById, customerDataResponse] =
    useFindCustomerDetailByIdMutation();
  const [customerImage, setCustomerImage] = useState([]) as any;

  useEffect(() => {
    if (customerData) setCustomerImage(customerData);
  }, [customerData]);

  useEffect(() => {
    if (!userData) {
      const data: any = localStorage.getItem("user");
      dispatch(setUser(JSON.parse(data)));
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("cartId") != "null" &&
      localStorage.getItem("cartId") != null
    ) {
      findByCartId({
        id: localStorage.getItem("cartId"),
      });
    }
  }, []);

  useEffect(() => {
    if (finbByCartIdResponse.isSuccess) {
      dispatch(setCart(finbByCartIdResponse.data));
    }
  }, [finbByCartIdResponse.isSuccess]);

  useEffect(() => {
    if (token) {
      findCustomerDetailById({
        token: token,
        id: customerId,
      });
    }
  }, [token]);

  useEffect(() => {
    if (customerDataResponse.isSuccess) {
      dispatch(setCustomer(customerDataResponse.data));
    }
  }, [customerDataResponse.isSuccess]);

  const handleFilter = () => { };
  useEffect(() => {
    if (logoutResponse.isSuccess) {
      navigate("/");
    }
  }, [logoutResponse.isSuccess]);

  return (
    <div
      className={`lg:px-10 px-2 flex h-[75px] md:h-[75px] w-[100%] border-b  z-10 bg-white ${props.position === "fixed" ? "fixed top-0 left-0 right-0" : ""
        }`}
    >
      <div className="container lg:mt-[0] md:mt-[10px]">
        <div className="flex items-center justify-between">
          <div className="hidden xl:flex mr-auto">
            <NavLink to={"/"}>
              <img
                src={require("../../assets/logo.png")}
                alt=""
                className="w-[120px] ml-[20px] "
              />
            </NavLink>
          </div>
          <div className="hidden xl:hidden mr-auto md:flex md:ml-[16px] ml-0">
            <NavLink to={"/"}>
              <img
                src={require("../../assets/favicon.png")}
                alt=""
                style={{ width: "80px", height: "60px", marginTop: "5px" }}
              />
            </NavLink>
          </div>
          <button
            className="w-10  items-center  md:hidden flex justify-center"
            onClick={handleSidebar}
          >
            {sidebar ? (
              <MdClose className="text-[24px]" />
            ) : (
              <MdMenu className="text-[24px]" />
            )}
          </button>

          <div className="md:flex md:mx-5 space-x-2 lg:mx-0 hidden  gap-5 lg:gap-6  ">
            {navList.map((item: any, index: number) =>
              item.title == "Sign In" && isLoggedIn ? (
                " "
              ) : (
                <NavLink
                  key={index}
                  to={item.link}
                  className={({ isActive }) =>
                    `text-gray-700 border-b-1 mt-[10px] md:text-md sm:text-sm font-bold hover:text-red-500 hover:font-bold 
                      `
                  }
                  onClick={() => {
                    switch (item.title) {
                      case "Sign In":
                        loginUser({});
                        localStorage.clear();
                        break;
                      //case "Download App":
                      //  window.location.replace("#download");
                      //  break;
                      //case "Latest News":
                      //  window.location.replace("#latest-news");
                      //  break;
                      case "Become a Partner":
                        window.location.replace("#become-a-patner");
                        break;
                      case "How It Works":
                        window.location.replace("#how-it-works");
                        break;
                      //case "Benefits":
                      // window.location.replace("#benefits");
                      // break;
                      //case "About Us":
                      // window.location.replace("#aboutus");
                      // break;
                      //case "Our Services":
                      // window.location.replace("#services");
                      // break;
                      case "Home":
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                        break;
                    }
                  }}
                >
                  {item.title}
                </NavLink>
              )
            )}

            {/**<HashLink smooth to="/#download">
                <button
                  className="rounded-full w-32 my-[22px]
                bg-[#E23744] text-white  md:text-sm text-xs font-medium h-8"
                >
                  DOWNLOAD APP
                </button>
              </HashLink>*/}
          </div>

          <div className="justify-center items-center md:hidden">
            {props.logo === "Yes" && (
              <img
                src={require("../../assets/logo.png")}
                alt=""
                className="w-[150px] justify-center items-center"
              />
            )}
          </div>

          <div className=" flex items-center justify-center mr-[35px] md:mr-0 ml-4 lg:ml-8 gap-8">
            {/* <div
                onClick={() => {
                  setDisplays(true);
                }}
                className="text-[30px] text-[#E23744] hover:text-red-500 hover:font-bold"
              >
                <div className="flex flex-row-reverse">
                  {(cartData && cartData?.length === 0) ||
                    (cartData && cartData?.length !== null && (
                      <p className="text-[15px] text-white text-center w-[20px] bg-red-500 h-[20px] rounded-3xl mb-2">
                        {cartData.length}
                      </p>
                    ))}
                  {bookingData.bookingDetail == null ? (
                    <IoBagOutline />
                  ) : (
                    <BsBagCheck />
                  )}
                </div>
              </div> */}

            {/* <Drawer
                className="h-[500px] w-[100%]"
                open={displays}
                anchor="right"
              >
                <CartDrawer
                  displays={displays}
                  handleFilter={handleFilter}
                  setDisplays={setDisplays}
                />
              </Drawer> */}

            {!isLoggedIn && (
              <div className="md:flex hidden mt-2">
                <button
                  className="bg-red-500 hover:bg-red-600 text-white px-4 rounded-md font-medium transition duration-300"
                  onClick={() => {
                    localStorage.setItem("redirectAfterLogin", window.location.pathname);
                    navigate("/profile/auth/login");
                  }}
                >
                  Sign In
                </button>
              </div>
            )}
            {isLoggedIn ? (
              <button onClick={() => navigate("/profile/account")}>
                {/* Desktop View */}
                <Box className="hidden md:flex">
                  {customerImage?.preSignedImageUrl ? (
                    <Box
                      className="md:mr-[24px] "
                      style={{
                        background: "lightgray",
                        backgroundImage: `url(${customerImage?.preSignedImageUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        height: 60,
                        width: 60,
                        borderRadius: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        flexDirection: "column",
                        marginRight: "31px",
                      }}
                    />
                  ) : (
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    >
                      <Avatar
                        sx={{ width: 50, height: 50, bgcolor: "#d3d3d3", color: "#ED1C24", fontWeight: "bold" }}
                      >
                        {customerData?.name?.charAt(0)?.toUpperCase()}
                      </Avatar>
                    </Badge>
                  )}
                </Box>

                {/* Mobile View */}
                <Box className="flex md:hidden mr-[-15px]">
                  {customerImage?.imageUrl ? (
                    <Box
                      style={{
                        background: "lightgray",
                        backgroundImage: `url(${customerImage?.preSignedImageUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        height: 45,
                        width: 45,
                        borderRadius: "100px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        flexDirection: "column",
                      }}
                    />
                  ) : (
                    <Avatar
                      sx={{ width: 45, height: 45, bgcolor: "#d3d3d3", color: "#ED1C24", fontWeight: "bold" }}
                    >
                      {customerData?.name?.charAt(0)?.toUpperCase()}
                    </Avatar>
                  )}
                </Box>
              </button>
            ) : null}

          </div>
          <div
            className={`flex-col fixed z-[2] overflow-scroll bg-white h-[100vh] left-0 top-0 w-[200px] shadow-lg p-5 ${sidebar ? "flex" : "hidden"
              }`}
          >
            <div className="mb-4">
              <NavLink to={"/"}>
                <img
                  src={require("../../assets/logo.png")}
                  alt=""
                  style={{ width: "140px", height: "80px" }}
                />
              </NavLink>
              {!isLoggedIn && (
                <div>
                  <button
                    className="text-gray-500 text-md font-semibold py-2 md:px-5 pr-5 mt-2 hover:text-gray-700 hover:font-bold"
                    onClick={() => {
                      localStorage.setItem("redirectAfterLogin", window.location.pathname);
                      navigate("/profile/auth/login");
                    }}
                  >
                    Sign In
                  </button>
                  <div className="border-b-2 mt-2 w-full"></div>
                </div>
              )}
            </div>

            {navLists.map((item: any, index: number) => (
              <NavLink
                key={index}
                to={item.link}
                className={({ isActive }) =>
                  `text-gray-500 text-md flex items-center font-semibold py-2 md:px-5 pr-5 hover:text-gray-700 hover:font-bold ${isActive ? "text-gray-700" : ""
                  }`
                }
                onClick={() => {
                  if (item.title === "Logout") {
                    setVisible(true);
                  }
                }}
              >
                <p className="mr-2 w-6 h-6">{item.icon}</p>
                <p className="text-[12px] text-[#58595B]">{item.title}</p>
              </NavLink>
            ))}
            {/* <HashLink smooth to="/#download">
              <button
                className="rounded-full w-40 my-[18px]
              bg-[#E23744] text-white  md:text-sm text-xs font-medium h-8"
              >
                DOWNLOAD APP
              </button>
            </HashLink> */}
          </div>
        </div>
      </div>
      {sidebar && (
        <div
          className="bg-black bg-opacity-60 md:hidden fixed top-0 left-0 right-0 bottom-0 z-[1]"
          onClick={handleSidebar}
        ></div>
      )}
      {visible && (
        <RegularModal
          modalDialogStyle="lg:w-[430px] bg-[#F9F4EF] w-[390px] lg:h-[295px] h-[270px] rounded-[8px]"
          visible={visible}
          setVisible={setVisible}
        >
          <p
            onClick={() => {
              setVisible(false);
            }}
            className="flex justify-end m-1"
          >
            <MdCancel size={24} color={"#ED1C24"} />
          </p>
          <p className="text-center text-gray-500 mt-4 text-[#434343] text-[24px] font-semibold lg:text-[28px]">
            Are You Sure to Logout ?
          </p>
          <div className="flex flex-col md:flex-row md:items-center md:justify-center mx-[1.75rem] mt-10 gap-4">
            <button
              onClick={() => {
                setVisible(false);
              }}
              className="w-full md:w-1/2 bg-[#ED1C24] text-white font-semibold p-2 rounded-full shadow-md"
            >
              No
            </button>

            <button
              onClick={() => {
                {
                  logoutUser({});
                  localStorage.clear();
                  setVisible(false);
                  localStorage.removeItem("user");
                  dispatch(resetCustomer());
                  dispatch(reset());
                  dispatch(resetNav());
                  localStorage.setItem("isLoggedIn", "false");
                }
              }}
              className="w-full md:w-1/2 bg-[#ED1C24] text-white p-2 font-semibold rounded-full mt-4 md:mt-0 shadow-md"
            >
              Yes
            </button>
          </div>
        </RegularModal>
      )}
    </div>
  );
};

export default Header;
